(() => {
  const items = ['SAADGI','WAADA','AAYAT','Kurti','3-piece suit','Co order set','Dresses','Plus size','Best sellers'];
  const clean = s => (s || '').replace(/\s+/g, ' ').trim();
  const handle = s => s.toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');

  function installMega() {
    const header = document.querySelector('header-component,#header-group,header');
    if (!header || header.querySelector('.swv-mega-panel')) return;

    const trigger = [...header.querySelectorAll('a,summary,button')]
      .find(el => /^shop( now)?$/i.test(clean(el.textContent).replace(/[▾⌄▼]/g,'')));

    if (!trigger) return;

    const owner = trigger.closest('li,details,.menu-list__list-item') || trigger.parentElement;
    header.classList.add('swv-header');
    trigger.classList.add('swv-shop-trigger');
    owner?.classList.add('swv-shop-owner');

    items.forEach(name => {
      [...header.querySelectorAll('a')].forEach(a => {
        if (clean(a.textContent).toLowerCase() === name.toLowerCase()) {
          a.classList.add('swv-old-link');
          a.closest('li')?.classList.add('swv-old-item');
        }
      });
    });

    const panel = document.createElement('nav');
    panel.className = 'swv-mega-panel';

    items.forEach(name => {
      const old = [...header.querySelectorAll('a')]
        .find(a => clean(a.textContent).toLowerCase() === name.toLowerCase());
      const a = document.createElement('a');
      a.textContent = name;
      a.href = old?.getAttribute('href') || `/collections/${handle(name)}`;
      panel.appendChild(a);
    });

    header.appendChild(panel);

    if (!document.querySelector('#swv-mega-style')) {
      const style = document.createElement('style');
      style.id = 'swv-mega-style';
      style.textContent = `
        #header-group,.swv-header,.swv-header .header{background:#f5f0e8!important}
        .swv-header{position:relative!important;overflow:visible!important;z-index:999}
        .swv-shop-trigger{color:#9b3a2f!important;font-weight:600!important}
        @media(min-width:990px){
          .swv-shop-owner>ul,.swv-shop-owner .header__submenu,.swv-shop-owner .menu-list__submenu,.swv-old-item,.swv-old-link{display:none!important}
          .swv-mega-panel{display:none;position:absolute;top:100%;left:15vw;right:15vw;background:#f5f0e8;padding:44px 56px;box-shadow:0 18px 45px #0002;border-radius:0 0 8px 8px;z-index:99999;grid-template-columns:1fr 1fr;gap:30px 110px}
          .swv-mega-panel.is-open{display:grid!important}
          .swv-mega-panel a{font-size:20px;font-weight:700;color:#4a3326!important;text-decoration:none!important;white-space:nowrap}
          .swv-mega-panel a:hover{color:#8a241c!important}
        }
        @media(max-width:989px){.swv-mega-panel{display:none!important}}
      `;
      document.head.appendChild(style);
    }

    let timer;
    const open = () => {
      clearTimeout(timer);
      panel.classList.add('is-open');
      if (owner?.tagName === 'DETAILS') owner.removeAttribute('open');
    };
    const close = () => timer = setTimeout(() => panel.classList.remove('is-open'), 150);

    [trigger, owner, panel].filter(Boolean).forEach(el => {
      el.addEventListener('mouseenter', open);
      el.addEventListener('mouseleave', close);
      el.addEventListener('focusin', open);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installMega);
  else installMega();
  document.addEventListener('shopify:section:load', installMega);
})();
